export default {
    abbreviation: '繁',
    inputPlaceholder: '请输入',
    defaultRulesLabel: '该字段',
    YxAction: {
      plm: '更多',
      pbm: '批量操作',
      tm: '是否{defTitps}？',
      bm: '返回',
      jm: '跳转',
      rm: '重置',
      sm: '提交',
      am: '功能',
      pm: '弹窗',
      asm: '操作成功',
      ssm: '提交成功',
      usm: '上传成功',
      dsm: '下载成功',
    },
    YxButton: {
      t: '按钮'
    },
    YxDropdown: {
      t: '未赋值'
    },
    YxListPage: {
      tm: '结果列表',
    },
    YxMasterSlave: {
      am: '你还没有选择节点！',
      em: '你还没有选择节点！'
    },
    YxPopconfirm: {
      ot: '是',
      ct: '否'
    },
    YxSearchPanel: {
      uf: '展开',
      f: '收起',
      qt: '查询',
      rt: '重置',
      ht: '搜索条件'
    },
    YxSku: {
      cm: '请先选择规格属性',
      dt: '是否删除此规格？',
      dot: '是',
      dct: '否',
      dbt: '删除',
      at: '添加',
      cip: '请选择',
      pt: '配置规格',
      addot: '新增规格项',
      ost: '规格设置',
      oit: '规格信息',
      ot: '确定',
      ct: '取消',
      ggl: '规格项',
      ggz: '规格值',
      ggzem: '规格值不能重复',
      addggz: '添加规格值',
      agg: '添加规格',
      sl: '单规格',
      ml: '多规格',
      ggtyle: '规格类型',
      st: '保存',
      xn: '项目名称',
      xval: '项目值',
      mtx: '上移',
      mbx: '下移',
      dat: '删除',
      bc: '批量修改',
    },
    YxTable: {
      ect: '确认',
      ecelt: '取消',
      et: '编辑',
      nct: '未选中任何一项',
      sn: '序号',
      ft: '筛选',
      act: '操作',
      sumt: '共{total}条数据',
      allCheck: '全选'
    },
    YxStatus: {
      it: '启用中',
      wt: '已停用',
      st: '已完成',
      et: '错误提示'
    },
    YxTree: {
      st: '请输入搜索条件',
      nc: '你没有选择任何节点！',
      dfkey: '"defaultSelectedKeys" 必须为数组格式'
    },
    Editor: {
      rusm: '仅支持上传图片文件',
      usm: '上传成功',
      uem: '上传失败',
    },
    YxUpload: {
      cubt: '点击上传',
      cutt: '点击上传',
      cumt: '点击上传',
      cutht: '点击上传',
      dt: '确定要删除该项吗？',
      dnt: '上传文件成功',
      ert: '上传失败！',
      rt: '删除文件成功',
      lt: '上传数量超出限制！',
      st: '上传文件大小超出限制！',
    },
    YxModal: {
      ot: '确定',
      ct: '取消',
    },
    Certificates: {
      cm: '请输入正确的身份证号码',
      pm: '请输入正确的护照号码',
      jm: '请输入正确的军官证号码',
    },
    defaultRules: {
      rt: '{label}不能为空',
      maxt: '{label}长度不能大于{len}个字符',
      lent: '{label}长度需{len}个字符',
      mint: '{label}长度不能少于{len}个字符',
      wnlcm: '请使用中文、字母、下划线、数字',
      nc: '不支持中文',
      wnlt: '请使用字母，下划线，数字',
      wnlclt: '请使用字母，下划线，横线，数字',
      hnlt: '只能字母开头,请使用字母，下划线，数字，点号',
    },
    Range: {
      pc: "{label}请填写完整",
      order: "结束时间不能超过开始时间"
    },
    Email: {
      ecm: '请输入正确的邮箱格式'
    },
    PassWord: {
      em: '两次输入的密码不一致',
      rm: '请输入{l1} ~ {l2} 位的密码',
      lv1: '密码为数字、字母、特殊符号的任意的一种组合',
      lv2: '密码为数字、字母、特殊符号两种及以上组合',
      lv3: '密码为数字、字母、特殊符号三种组合',
    },
    Phone: {
      pem: '手机号码有误',
      tem: '电话号码有误',
    },
    Url: {
      em: '请输入正确的url格式'
    },
    YxCascader: {
      ipt: '请选择',
    },
  }
  


// WEBPACK FOOTER //
// ./src/config/langs/tc/yxWidgetTc.js